import { CheckCircleFilled } from "@ant-design/icons";
import { Button, Form, Input, message, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import Noti from "app/components/Noti";
import Policy from "app/components/Policy";
import Bg from "assets/images/bg-login.png";
import Logo from "assets/images/logo-blue.png";
import { APP_COLOR } from "constant";
import { useHandleSubmitApi } from "hook";
import { IForgotPasswordInputModel } from "interfaces";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthServices } from "services";
import "../Login/Login.style.scss";
import { PUBLIC_ROUTE } from "constant/routes/page";

type P_Props = {};

const ForgorPasswordPresenter = (props: P_Props) => {
  const [visibleNoti, setVisibleNoti] = useState(false);
  const navigate = useNavigate();
  const [form] = useForm();

  const [handleSubmitApi, loading] = useHandleSubmitApi(async (data: IForgotPasswordInputModel) => {
    const dataRes = await AuthServices.forgotPassword(data);
    if (dataRes) {
      message.success("PLEASE_CHECK_EMAIL_FOR_YOU");
      navigateLogin();
    }
  });

  const navigateLogin = () => {
    navigate(PUBLIC_ROUTE.LOGIN);
  };

  return (
    <>
      <Modal
        open={true}
        width={1680}
        bodyStyle={{ height: "calc(100vh - 190px)" }}
        footer={null}
        closable={false}
        wrapClassName="login-modal"
      >
        <div className="login">
          <div className="login-form">
            <div className="login-form__inner">
              <img src={Logo} alt="" width={196} style={{ marginTop: 20 }} />
              <h1>Quên mật khẩu</h1>
              <Form className="mt_2" form={form}>
                <div className="mb_2 text-center">
                  Nhập vào E-mail bạn dùng để đăng ký tài khoản, chúng tôi sẽ giúp bạn đặt lại mật khẩu.
                </div>
                <Form.Item
                  name={"email"}
                  rules={[
                    { required: true, message: "Vui lòng nhập Email" },
                    { type: "email", message: "Không đúng định dạng" },
                  ]}
                >
                  <Input size="large" required placeholder="Email" type="email" />
                </Form.Item>
                <Button
                  size="large"
                  className="btn btn-full mt_1"
                  onClick={() => form.validateFields().then(handleSubmitApi)}
                  loading={loading}
                >
                  Đặt lại mật khẩu
                </Button>
                <div className="text-center" style={{ marginTop: 15 }}>
                  Nếu bạn đã có tài khoản?{" "}
                  <span className="c-pointer" style={{ color: APP_COLOR.PRIMARY }} onClick={navigateLogin}>
                    Đăng Nhập
                  </span>
                </div>
              </Form>
              <div className="login-form__footer">
                <Policy />
              </div>
            </div>
          </div>

          <div className="login-image">
            <img src={Bg} alt="" height={"100%"} width={"100%"} />
          </div>
        </div>
      </Modal>

      {visibleNoti && (
        <Noti
          visible={visibleNoti}
          icon={{ color: "browse", children: <CheckCircleFilled style={{ color: "#D38123", fontSize: 64 }} /> }}
          title={"Thành công"}
          subTitle={
            "Email đã được gửi đến địa chỉ trên với một liên kết để đặt mật khẩu mới cho bạn. Vui lòng kiểm tra Email."
          }
          actions={
            <>
              <Button
                size="large"
                className="btn btn-outline"
                style={{ width: 240 }}
                onClick={() => {
                  setVisibleNoti(false);
                  navigate(PUBLIC_ROUTE.LOGIN);
                }}
              >
                Quay lại trang đăng nhập
              </Button>
            </>
          }
        />
      )}
    </>
  );
};

export default ForgorPasswordPresenter;
